// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4dd356de] .noWrap {\n  white-space: nowrap;\n}\n[data-v-4dd356de] .form-control.is-invalid {\n  border-color: #f05050 !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
